module.exports = __webpack_public_path__ + "static/bgImage-48e13cd2c609243f81d7dbcab2849eea.jpg";